import { FileItem } from '@inno-sdks/files'

import { mimeTypes } from '../constants'
import { ClusterOfficeAppType } from '../enums/clusterOffice'

/**
 * Determines the Cluster Office app type based on the file item's MIME type.
 *
 * @param {FileItem} item - The file item containing metadata with MIME type.
 * @returns {ClusterOfficeAppType | undefined} The corresponding Cluster Office app type or undefined if no match.
 */
export function getClusterOfficeAppType(
  item: FileItem
): ClusterOfficeAppType | undefined {
  const mimeType = item.metaData.mimeType

  if (!mimeType) {
    return
  }

  if (Object.values(mimeTypes.document).includes(mimeType)) {
    return ClusterOfficeAppType.Document
  } else if (Object.values(mimeTypes.spreadsheet).includes(mimeType)) {
    return ClusterOfficeAppType.Spreadsheet
  } else if (Object.values(mimeTypes.presentation).includes(mimeType)) {
    return ClusterOfficeAppType.Slide
  } else if (mimeType === mimeTypes.pdf.pdf) {
    return ClusterOfficeAppType.Pdf
  }
}

/**
 * Checks if a file item is recognized as a Cluster Office file based on its MIME type.
 *
 * @param {FileItem} item - The file item containing metadata with MIME type.
 * @returns {boolean} True if the file is a Cluster Office file, false otherwise.
 */
export function isClusterOfficeFile(item: FileItem): boolean {
  return [
    ...Object.values(mimeTypes.document),
    ...Object.values(mimeTypes.spreadsheet),
    ...Object.values(mimeTypes.presentation),
    mimeTypes.pdf.pdf,
    mimeTypes.plainDocument.txt
  ].includes(item.metaData.mimeType)
}
